import { render } from "./SectionItem.vue?vue&type=template&id=5d1fa8ac&scoped=true"
import script from "./SectionItem.vue?vue&type=script&lang=js"
export * from "./SectionItem.vue?vue&type=script&lang=js"

import "./SectionItem.vue?vue&type=style&index=0&id=5d1fa8ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1fa8ac"]])

export default __exports__